import {ROOT} from './api.js';
import axios from 'axios';
axios.defaults.baseURL = ROOT;

axios.defaults.headers['X-Requested-LOGIN'] = 'plugin';
axios.interceptors.request.use(function (config) {
  let token = window.localStorage.getItem('DTS_USER_TOKEN');
  let d = { token };
  let par = config.method === 'get' ? 'params' : 'data';
  if (config[par]) {
    config.params = { ...config[par], ...d };
  } else {
    config.params = d;
  }
  return config;
});

//添加一个返回拦截器
axios.interceptors.response.use(function(response){
  return response.data;
});

export default axios;